export class WCAGModel {
    public isWCAG: boolean;
    public fontSize: number;
}